<app-main-menu></app-main-menu>
<div class="d-flex margin-menu w-100">
  <app-side-bar></app-side-bar>
  <div>
    <router-outlet></router-outlet>
  </div>
</div>
